var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 4.5C8.09375 2.80273 6.69727 1.40625 5 1.40625C3.28125 1.40625 1.90625 2.80273 1.90625 4.5C1.90625 4.86523 2.05664 5.40234 2.42188 6.13281C2.78711 6.82031 3.25977 7.55078 3.75391 8.23828C4.20508 8.83984 4.63477 9.37695 5 9.80664C5.34375 9.37695 5.77344 8.83984 6.22461 8.23828C6.71875 7.55078 7.19141 6.82031 7.55664 6.13281C7.92188 5.40234 8.09375 4.86523 8.09375 4.5ZM9.125 4.5C9.125 6.30469 6.84766 9.20508 5.66602 10.6016C5.25781 11.0957 5 11.375 5 11.375C5 11.375 4.7207 11.0957 4.3125 10.6016C3.13086 9.20508 0.875 6.30469 0.875 4.5C0.875 2.22266 2.72266 0.375 5 0.375C7.27734 0.375 9.125 2.22266 9.125 4.5ZM5.6875 4.5C5.6875 4.13477 5.36523 3.8125 5 3.8125C4.61328 3.8125 4.3125 4.13477 4.3125 4.5C4.3125 4.88672 4.61328 5.1875 5 5.1875C5.36523 5.1875 5.6875 4.88672 5.6875 4.5ZM3.28125 4.5C3.28125 3.89844 3.60352 3.33984 4.14062 3.01758C4.65625 2.7168 5.32227 2.7168 5.85938 3.01758C6.375 3.33984 6.71875 3.89844 6.71875 4.5C6.71875 5.12305 6.375 5.68164 5.85938 6.00391C5.32227 6.30469 4.65625 6.30469 4.14062 6.00391C3.60352 5.68164 3.28125 5.12305 3.28125 4.5Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocale);
export default __webpack_public_path__ + "static/media/locale.90e970209ddf5316e164eb3b892391d3.svg";
export { ForwardRef as ReactComponent };